interface IsChunkLoadErrorParams {
  name?: string
  message?: string
}

const CHUNK_LOAD_MESSAGE_PATTERNS = [
  /Loading (CSS )?chunk \d+ failed/,
  /Failed to load chunk /,
  /failed to load chunks for page /,
]

/**
 * A dynamic `import()` for a content-hashed bundle that is no longer on the CDN — the classic
 * stale-deploy chunk miss — surfaces differently per bundler, so all three known shapes are matched:
 * webpack's JSONP `Loading chunk N failed.`, Turbopack's runtime `Failed to load chunk <url> from
 * module <id>`, and Turbopack's page-chunk loader, which swallows the miss into a bare
 * `console.error('failed to load chunks for page ' + page)` that never reaches the router.
 *
 * Both bundlers name the real error `ChunkLoadError`, so a caller holding the `Error` matches on
 * `name` alone; RUM `beforeSend` only sees the serialized message, so the message forms must each
 * match on their own.
 */
export const isChunkLoadError = ({ name, message }: IsChunkLoadErrorParams): boolean =>
  name === 'ChunkLoadError' || CHUNK_LOAD_MESSAGE_PATTERNS.some((pattern) => pattern.test(message ?? ''))
